// extracted by mini-css-extract-plugin
module.exports = {"rectangleSkeleton":"RectangleSkeleton_rectangleSkeleton__sQdJG","shimmerEffect":"RectangleSkeleton_shimmerEffect__IkOZA","desktopOnly":"RectangleSkeleton_desktopOnly__TJ2Nn"};